import { createTheme } from '@mui/material/styles';

/**
 * Theme MUI base del Client Portal. Tokens derivados del design system de Diego
 * Obando (handoff Login.html). El primary color se overridea dinámicamente por
 * el TenantProvider cuando el workspace tiene un PrimaryColor configurado.
 */
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1f6feb',
    },
    background: {
      default: '#fafaf9',
      paper: '#ffffff',
    },
    text: {
      primary: '#0a0a0a',
      secondary: '#6b6b6b',
    },
    divider: '#e7e5e1',
  },
  typography: {
    fontFamily: '"Geist", system-ui, -apple-system, sans-serif',
    h1: { letterSpacing: '-0.025em', fontWeight: 700 },
    h2: { letterSpacing: '-0.02em', fontWeight: 700 },
    h3: { letterSpacing: '-0.015em', fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: {
    borderRadius: 11,
  },
});
